import { render } from "./ModalImportExcel.vue?vue&type=template&id=65188cb4"
import script from "./ModalImportExcel.vue?vue&type=script&lang=js"
export * from "./ModalImportExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__